<template>
  <div>
    <breadcrumbs home="Bulk container type"/>

      <v-card flat>
        <v-form v-model="valid">
          <v-container class="pt-6 px-6 purtrak-scrollable" fluid>
            <v-row dense>
              <v-col cols="12" sm="5">
                <v-text-field label="Name" v-model="type.name" :rules="[fieldRules.required,fieldRules.maxLength(50)]" :counter="50" outlined dense/>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="6" sm="2">
                <decimal-number-input label="Capacity" v-model="type.capacity" prefix="" suffix="litres" :precision="0" integer/>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
        <v-divider/>
        <v-card-actions class="pr-6">
          <v-spacer/>
          <v-btn plain color="primary" @click="cancel">Cancel</v-btn>
          <v-btn color="primary" :loading="saving" @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    <confirm-leave v-model="next"/>
  </div>
</template>

<script>
import confirmLeave from '@/mixins/confirmLeave'

export default {
  name: 'InventoryBulkContainersTypesEdit',
  mixins: [confirmLeave],
  props: {
    id: {type:String, required:false}
  },
  data () {
    return {
      type: {},
      dirty: false,
      saving: false,
      loading: false,
      valid: true
    }
  },
  watch: {
    type: {
      handler() {this.dirty = true;},
      immediate: true,
      deep: true
    }
  },
  async created() {
    if (this.id) {
      this.loading = true;
      const results = await this.$apiCall(`query InventoryBulkContainersTypesEdit($id:ID!) {
                                              bulkContainerType(id:$id) {
                                                id,name,capacity,pictureURL
                                              }
                                            }`,
                                          {id:this.id});
      if (!results.error) {
        this.type = results.data.bulkContainerType;
        this.loading = false;
      }
    }
    else
      this.type = {name:'',capacity:210};
    this.$nextTick(() => {
      this.dirty = false;
    });
  },

  methods: {
    cancel() {
      this.$router.back();
    },
    async save() {
      if (!this.valid) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }
      this.saving = true;
      // eslint-disable-next-line no-unused-vars
      const {pictureURL, ...input} = this.type;
      const results = await this.$apiCall(`mutation InventoryBulkContainersTypesEdit($input: BulkContainerTypeInput!) {
                                             bulkContainerTypeCreate(input:$input) {id}
                                           }`,
                                          {input})
      this.saving = false;
      if (!results.error) {
        this.dirty = false;
        this.$router.back();
        this.$store.commit('setError', {type:'success',message:`${this.id?'Updated':'Created'} bulk container type ${this.type.name}`});
      }
    }
  }
}
</script>